import axios from 'axios';

export default {
  name: 'CardImageMaker',
  props: {
    batchNumber: {
      type: String,
      required: true
    },
    cardNumber: {
      type: String,
      required: true
    },
    validDays: {
      type: Number,
      required: true
    },
    cardType: {
      type: String,
      default: 'vip'
    }
  },
  data() {
    // 根据validDays计算初始的有效期类型
    let validityType = 'month'; // 默认月卡
    if (this.validDays === 7) {
      validityType = 'week';
    } else if (this.validDays === 30) {
      validityType = 'month';
    } else if (this.validDays === 365) {
      validityType = 'year';
    } else {
      validityType = 'custom';
    }
  
    return {
      cardBackgroundImage: null, // 背景图片数据URL
      // 添加背景模板及对应的配色方案
      // 支持动态加载，自动检测 templates 目录下的图片文件（jpg、jpeg、png、webp等格式）
      backgroundTemplates: [],
      // 支持的图片格式
      supportedImageFormats: ['.jpg', '.jpeg', '.png', '.webp', '.gif', '.bmp'],
      // 预定义的配色方案 - 根据实际图片调整
      // 预定义的配色方案 - 根据实际图片调整
      colorSchemes: {
        // 第一张 - 红色系
        red: {
          title: { color: '#fffafa', strokeColor: '#ef0b0b', strokeWidth: 2 },
          batchNumber: { color: '#fdfcfc', strokeColor: '#ffffff', strokeWidth: 1 },
          cardNumber: { color: '#ffffff', strokeColor: '#ffffff', strokeWidth: 1 },
          validity: { color: '#ffffff', strokeColor: '#fb0909', strokeWidth: 2 },
          website: { color: '#fdfcfc', strokeColor: '#ffffff', strokeWidth: 1 },
          separator: { color: '#ffffff', width: 3 }
        },
        // 第二张 - 蓝色背景配蓝色文字
        blue: {
          title: { color: '#0526FF', strokeColor: '#0526FF', strokeWidth: 2 },
          batchNumber: { color: '#0526FF', strokeColor: '#0526FF', strokeWidth: 1 },
          cardNumber: { color: '#0526FF', strokeColor: '#0526FF', strokeWidth: 1 },
          validity: { color: '#0526FF', strokeColor: '#0526FF', strokeWidth: 2 },
          website: { color: '#0526FF', strokeColor: '#0526FF', strokeWidth: 1 },
          separator: { color: '#0526FF', width: 3 }
        },
        // 第三张 - 红色背景配紫色/洋红文字
        purple: {
          title: { color: '#ffffff', strokeColor: '#4CAF50', strokeWidth: 2 },
          batchNumber: { color: '#81C784', strokeColor: '#81C784', strokeWidth: 1 },
          cardNumber: { color: '#81C784', strokeColor: '#81C784', strokeWidth: 1 },
          validity: { color: '#ffffff', strokeColor: '#388E3C', strokeWidth: 2 },
          website: { color: '#81C784', strokeColor: '#81C784', strokeWidth: 1 },
          separator: { color: '#81C784', width: 3 }
           
        },
        // 第四张 - 绿色系
        green: {
          title: { color: '#0526FF', strokeColor: '#0526FF', strokeWidth: 2 },
          batchNumber: { color: '#0526FF', strokeColor: '#0526FF', strokeWidth: 1 },
          cardNumber: { color: '#0526FF', strokeColor: '#0526FF', strokeWidth: 1 },
          validity: { color: '#0526FF', strokeColor: '#0526FF', strokeWidth: 2 },
          website: { color: '#0526FF', strokeColor: '#0526FF', strokeWidth: 1 },
          separator: { color: '#0526FF', width: 3 }
        },
        // 第五张 - 金色系
        gold: {
          title: { color: '#ffffff', strokeColor: '#FFD700', strokeWidth: 2 },
          batchNumber: { color: '#FFF176', strokeColor: '#FFF176', strokeWidth: 1 },
          cardNumber: { color: '#FFF176', strokeColor: '#FFF176', strokeWidth: 1 },
          validity: { color: '#ffffff', strokeColor: '#FFC107', strokeWidth: 2 },
          website: { color: '#FFF176', strokeColor: '#FFF176', strokeWidth: 1 },
          separator: { color: '#FFF176', width: 3 }
        },
        // 第六张 - 粉色系
        pink: {
          title: { color: '#ffffff', strokeColor: '#E91E63', strokeWidth: 2 },
          batchNumber: { color: '#F48FB1', strokeColor: '#F48FB1', strokeWidth: 1 },
          cardNumber: { color: '#F48FB1', strokeColor: '#F48FB1', strokeWidth: 1 },
          validity: { color: '#ffffff', strokeColor: '#C2185B', strokeWidth: 2 },
          website: { color: '#F48FB1', strokeColor: '#F48FB1', strokeWidth: 1 },
          separator: { color: '#F48FB1', width: 3 }
        },
        // 第七张 - 青色系
        cyan: {
          title: { color: '#ffffff', strokeColor: '#00BCD4', strokeWidth: 2 },
          batchNumber: { color: '#28DBFB', strokeColor: '#28DBFB', strokeWidth: 1 },
          cardNumber: { color: '#28DBFB', strokeColor: '#28DBFB', strokeWidth: 1 },
          validity: { color: '#ffffff', strokeColor: '#0097A7', strokeWidth: 2 },
          website: { color: '#28DBFB', strokeColor: '#28DBFB', strokeWidth: 1 },
          separator: { color: '#4DD0E1', width: 3 }
        },
        // 第八张 - 橙色系
        orange: {
          title: { color: '#ffffff', strokeColor: '#FF5722', strokeWidth: 2 },
          batchNumber: { color: '#FF8A65', strokeColor: '#FF8A65', strokeWidth: 1 },
          cardNumber: { color: '#FF8A65', strokeColor: '#FF8A65', strokeWidth: 1 },
          validity: { color: '#ffffff', strokeColor: '#E64A19', strokeWidth: 2 },
          website: { color: '#FF8A65', strokeColor: '#FF8A65', strokeWidth: 1 },
          separator: { color: '#FF8A65', width: 3 }
        },
        // 第九张 - 深蓝背景配红色文字
        dark: {
          title: { color: '#ff1744', strokeColor: '#ff1744', strokeWidth: 2 },
          batchNumber: { color: '#ff1744', strokeColor: '#ff1744', strokeWidth: 1 },
          cardNumber: { color: '#ff1744', strokeColor: '#ff1744', strokeWidth: 1 },
          validity: { color: '#ff1744', strokeColor: '#ff1744', strokeWidth: 2 },
          website: { color: '#ff1744', strokeColor: '#ff1744', strokeWidth: 1 },
          separator: { color: '#ff1744', width: 3 }
        }
      },
      cardInfo: {
        batchNumber: this.batchNumber,
        cardNumber: this.cardNumber,
        validityType: validityType,
        validDays: this.validDays,
        website: 'yuanbida.net'
      },
      // 文字类型定义
      textTypes: [
        { value: 'title', label: '标题' },
        { value: 'batchNumber', label: '批次号' },
        { value: 'cardNumber', label: '卡密' },
        { value: 'validity', label: '有效期' },
        { value: 'website', label: '网址' }
      ],
      // 激活的字体设置选项卡
      activeFontTab: 'title',
      // 字体设置（更新为用户提供的默认值）
      fontSettings: {
        title: {
          fontFamily: "'Microsoft YaHei', sans-serif",
          fontSize: 45,
          isBold: true,
          isItalic: false,
          letterSpacing: 5,
          color: '#fffafa',
          strokeColor: '#ef0b0b',
          strokeWidth: 1
        },
        batchNumber: {
          fontFamily: "'Microsoft YaHei', sans-serif",
          fontSize: 20,
          isBold: false,
          isItalic: false,
          letterSpacing: 4,
          color: '#fdfcfc',
          strokeColor: '#ffffff',
          strokeWidth: 1
        },
        cardNumber: {
          fontFamily: "'Microsoft YaHei', sans-serif",
          fontSize: 20,
          isBold: false,
          isItalic: false,
          letterSpacing: 4,
          color: '#ffffff',
          strokeColor: '#ffffff',
          strokeWidth: 1
        },
        validity: {
          fontFamily: "'Microsoft YaHei', sans-serif",
          fontSize: 44,
          isBold: true,
          isItalic: false,
          letterSpacing: 5,
          color: '#ffffff', // 保留默认颜色，用户提供的设置中缺少此项
          strokeColor: '#fb0909',
          strokeWidth: 1
        },
        website: {
          fontFamily: "'Microsoft YaHei', sans-serif",
          fontSize: 18,
          isBold: false,
          isItalic: false,
          letterSpacing: 2,
          color: '#ffffff',
          strokeColor: '#ffffff',
          strokeWidth: 1
        },
        logo: {
          fontFamily: "'Microsoft YaHei', sans-serif",
          fontSize: 60,  // logo大小
          isBold: false,
          isItalic: false,
          letterSpacing: 0,
          color: '#ffffff',  // 背景色
          strokeColor: '#000000',  // 边框色
          strokeWidth: 0,
          bgSize: 60,  // 背景色大小
          maskShape: 'circle'  // 蒙版形状
        }
      },
      // 添加文字位置状态（使用相对位置，会根据图片尺寸自动调整）
      textPositions: {
        title: { x: 0.5, y: 0.25 },  // 标题居中，在图片上半部分
        batchNumber: { x: 0.5, y: 0.45 },  // 批次号居中
        cardNumber: { x: 0.5, y: 0.55 },  // 卡密居中
        validity: { x: 0.75, y: 0.75 },  // 周卡在右侧
        website: { x: 0.5, y: 0.88 },  // 网址居中底部
        logo: { x: 0.15, y: 0.15 }  // Logo位置
      },
      // 添加分隔线位置状态（使用相对位置）
      separatorPosition: { y: 0.35 },
      separatorColor: '#ffffff', // 分隔线颜色
      separatorWidth: 3, // 分隔线宽度
      // Logo相关数据
      logoImage: null, // Logo图片数据URL
      // Logo设置已整合到fontSettings.logo中统一管理
      // logo位置使用textPositions.logo
      isDraggingLogo: false, // 是否正在拖拽Logo
      isLogoSelected: false, // Logo是否被选中（显示四角手柄）
      isResizingLogo: false, // 是否正在调整Logo大小
      resizeCorner: null, // 调整的角落位置 (se/sw/ne/nw)
      logoResizeHandleSize: 8, // Logo调整手柄大小（像素）
      isDragging: false, // 是否正在拖拽
      currentDraggedElement: null, // 当前拖拽的元素类型（text-文字, separator-分隔线）
      currentDraggedText: null, // 当前拖拽的文字类型
      dragOffset: { x: 0, y: 0 }, // 拖拽偏移量
      isShiftPressed: false, // 是否按下了Shift键
      initialPosition: null, // 拖拽开始时的初始位置
      dragDirection: null, // Shift键模式下的移动方向（horizontal/vertical）
      showHitAreas: false, // 是否显示点击区域（默认不显示，点击后显示）
      selectedTextType: null, // 当前选中的文字类型
      newStyleName: '', // 新样式名称
      savedStyles: [], // 已保存的样式列表
      currentStyleIndex: -1, // 当前应用的样式索引
      lockHorizontal: true, // 是否锁定横向位置（默认打开）
      lockVertical: false, // 是否锁定纵向位置
      // 默认样式设置（更新为用户提供的默认值）
      defaultSettings: {
        fontSettings: {
          title: {
            fontFamily: "'Microsoft YaHei', sans-serif",
            fontSize: 45,
            isBold: true,
            isItalic: false,
            letterSpacing: 5,
            color: '#fffafa',
            strokeColor: '#ef0b0b',
            strokeWidth: 1
          },
          batchNumber: {
            fontFamily: "'Microsoft YaHei', sans-serif",
            fontSize: 20,
            isBold: false,
            isItalic: false,
            letterSpacing: 4,
            color: '#fdfcfc',
            strokeColor: '#ffffff',
            strokeWidth: 1
          },
          cardNumber: {
            fontFamily: "'Microsoft YaHei', sans-serif",
            fontSize: 20,
            isBold: false,
            isItalic: false,
            letterSpacing: 4,
            color: '#ffffff',
            strokeColor: '#ffffff',
            strokeWidth: 1
          },
          validity: {
            fontFamily: "'Microsoft YaHei', sans-serif",
            fontSize: 44,
            isBold: true,
            isItalic: false,
            letterSpacing: 5,
            color: '#ffffff', // 保留默认颜色，用户提供的设置中缺少此项
            strokeColor: '#fb0909',
            strokeWidth: 1
          },
          website: {
            fontFamily: "'Microsoft YaHei', sans-serif",
            fontSize: 18,
            isBold: false,
            isItalic: false,
            letterSpacing: 2,
            color: '#ffffff',
            strokeColor: '#ffffff',
            strokeWidth: 1
          }
        },
        textPositions: {
          title: { x: 0.5, y: 0.25 },
          batchNumber: { x: 0.5, y: 0.45 },
          cardNumber: { x: 0.5, y: 0.55 },
          validity: { x: 0.75, y: 0.75 },
          website: { x: 0.5, y: 0.88 }
        },
        separatorPosition: { y: 0.35 },
        separatorColor: '#ffffff',
        separatorWidth: 3
      }
    };
  },

  watch: {
    cardBackgroundImage(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.drawCardPreview();
          this.addMouseEvents(); // 重新添加事件监听以确保canvas已存在
        });
      }
    },
    // 监听props变化，更新本地数据
    batchNumber(newVal) {
      this.cardInfo.batchNumber = newVal;
    },
    cardNumber(newVal) {
      this.cardInfo.cardNumber = newVal;
    },
    validDays(newVal) {
      this.cardInfo.validDays = newVal;
      
      // 根据validDays自动设置有效期类型
      if (newVal === 7) {
        this.cardInfo.validityType = 'week';
      } else if (newVal === 30) {
        this.cardInfo.validityType = 'month';
      } else if (newVal === 365) {
        this.cardInfo.validityType = 'year';
      } else {
        this.cardInfo.validityType = 'custom';
      }
    },
    // 监听有效期类型变化，更新有效期天数
    'cardInfo.validityType'(newVal) {
      if (newVal === 'week') {
        this.cardInfo.validDays = 7;
      } else if (newVal === 'month') {
        this.cardInfo.validDays = 30;
      } else if (newVal === 'year') {
        this.cardInfo.validDays = 365;
      }
      // 自定义类型保持当前天数不变
    },
    // 监听卡信息变化，自动更新预览
    cardInfo: {
      handler() {
        if (this.cardBackgroundImage) {
          this.drawCardPreview();
        }
      },
      deep: true
    },
    // 监听字体设置变化，自动更新预览
    fontSettings: {
      handler() {
        if (this.cardBackgroundImage) {
          this.drawCardPreview();
        }
      },
      deep: true
    },
    // 监听分隔线设置变化，自动更新预览
    separatorColor() {
      if (this.cardBackgroundImage) {
        this.drawCardPreview();
      }
    },
    separatorWidth() {
      if (this.cardBackgroundImage) {
        this.drawCardPreview();
      }
    },
    // Logo设置已整合到fontSettings中，通过监听fontSettings来更新
  },
  // 修复事件监听的添加时机
  async mounted() {
    // 使用nextTick确保DOM已完全渲染
    this.$nextTick(async () => {
      this.addMouseEvents();
      // 先加载已保存的样式列表（包含从数据库加载配色方案）
      await this.loadSavedStyles();
      
      // 动态加载模板（支持多种格式：jpg、jpeg、png、webp等）
      await this.loadTemplatesDynamically();
      
      // 加载默认logo（返回Promise以便等待）
      const logoLoaded = this.loadDefaultLogoAsync();
      
      // 加载完成后再选择第一个模板（这样就能使用数据库中的配色方案）
      if (this.backgroundTemplates && this.backgroundTemplates.length > 0) {
        this.selectTemplate(this.backgroundTemplates[0]);
      }
      
      // 等待logo加载完成
      await logoLoaded;
      
      // 组件挂载时，如果有背景图片，绘制预览（此时logo已加载）
      if (this.cardBackgroundImage) {
        this.drawCardPreview();
      }
      
      // 自动恢复默认设置
      this.restoreDefaultSettingsSilent();
    });
  },

  // 组件销毁前清理事件监听器
  beforeDestroy() {
    this.removeMouseEvents();
  },
  
  methods: {

    // 获取卡类型中文名称
    getCardTypeName() {
      const typeMap = {
        'vip': '会员卡',
        'svip': '规划师卡',
        'admin': '管理员卡'
      };
      return typeMap[this.cardType] || '会员卡';
    },

    // 加载已保存的样式列表
    async loadSavedStyles() {
      try {
        const savedStyles = localStorage.getItem('cardImageSavedStyles');
        if (savedStyles) {
          this.savedStyles = JSON.parse(savedStyles);
        }
        // 加载已保存的配色方案（从数据库）
        await this.loadSavedColorSchemes();
      } catch (error) {
        console.error('加载样式列表失败:', error);
        this.savedStyles = [];
      }
    },

      // 动态加载模板图片（支持多种格式：jpg、jpeg、png、webp等）
    async loadTemplatesDynamically() {
      try {
        // 预定义的配色方案映射（template1-9）
        const colorSchemeMap = {
          'template1': 'red',
          'template2': 'blue',
          'template3': 'green',
          'template4': 'purple',
          'template5': 'gold',
          'template6': 'pink',
          'template7': 'cyan',
          'template8': 'orange',
          'template9': 'dark',
        };
        
        // 支持的最大模板数量（根据实际文件数量调整）
        const maxTemplates = 9;
        const templates = [];
        
        // 尝试加载各种格式的模板
        for (let i = 1; i <= maxTemplates; i++) {
          const templateName = `template${i}`;
          
          // 尝试每种支持的格式
          for (const format of this.supportedImageFormats) {
            const url = `/templates/${templateName}${format}`;
            
            // 检查图片是否存在
            try {
              const exists = await this.checkImageExists(url);
              if (exists) {
                const colorScheme = colorSchemeMap[templateName] || 'red';
                templates.push({ url, colorScheme });
                console.log(`[Template] 加载成功: ${url}`);
                break; // 找到一种格式后跳出，尝试下一个模板
              }
            } catch (e) {
              // 忽略错误，继续尝试下一种格式
            }
          }
        }
        
        // 如果找到模板，更新模板列表
        if (templates.length > 0) {
          this.backgroundTemplates = templates;
          console.log(`[Template] 共加载 ${templates.length} 个模板`);
        } else {
          // 如果未找到任何模板，使用默认配置（兼容旧版本）
          console.warn('[Template] 未找到任何模板文件，使用默认配置');
          this.backgroundTemplates = [
            { url: '/templates/template1.jpg', colorScheme: 'red' },
            { url: '/templates/template2.jpg', colorScheme: 'blue' },
            { url: '/templates/template3.jpg', colorScheme: 'green' },
            { url: '/templates/template4.jpg', colorScheme: 'purple' },
            { url: '/templates/template5.jpg', colorScheme: 'gold' },
          ];
        }
      } catch (error) {
        console.error('[Template] 动态加载模板失败:', error);
        // 出错时使用默认配置
        this.backgroundTemplates = [
          { url: '/templates/template1.jpg', colorScheme: 'red' },
          { url: '/templates/template2.jpg', colorScheme: 'blue' },
          { url: '/templates/template3.jpg', colorScheme: 'green' },
        ];
      }
    },
    
    // 检查图片是否存在
    checkImageExists(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
      });
    },

  // 加载已保存的配色方案（从数据库）
    async loadSavedColorSchemes() {
      try {
        const response = await axios.get('api/card-color-scheme/', {
          withCredentials: true
        });
        
        if (response.data.success && response.data.schemes) {
          // 合并数据库中的配色方案
          Object.keys(response.data.schemes).forEach(schemeName => {
            if (response.data.schemes[schemeName]) {
              this.colorSchemes[schemeName] = response.data.schemes[schemeName];
            }
          });
          
          // 从数据库加载位置信息到当前状态（位置是全局共享的，从任意一个模板读取即可）
          const firstScheme = Object.values(response.data.schemes)[0];
          if (firstScheme && firstScheme.textPositions) {
            this.textPositions = JSON.parse(JSON.stringify(firstScheme.textPositions));
            // 确保textPositions.logo存在（兼容旧数据）
            if (!this.textPositions.logo) {
              this.textPositions.logo = { x: 0.15, y: 0.15 };
            }
            console.log('从数据库加载位置信息成功:', this.textPositions);
          }
          if (firstScheme && firstScheme.separatorPosition) {
            this.separatorPosition = JSON.parse(JSON.stringify(firstScheme.separatorPosition));
            console.log('从数据库加载分隔线位置成功:', this.separatorPosition);
          }
          // 从数据库加载logo设置（优先使用第一个模板的大小作为全局值，颜色从各自模板加载）
          if (firstScheme && firstScheme.logo) {
            this.fontSettings.logo.color = firstScheme.logo.color;
            this.fontSettings.logo.maskShape = firstScheme.logo.maskShape;
            // 使用第一个模板的大小作为全局统一值
            this.fontSettings.logo.fontSize = firstScheme.logo.fontSize || 60;
            this.fontSettings.logo.bgSize = firstScheme.logo.bgSize || 60;
            console.log('从数据库加载logo设置成功:', this.fontSettings.logo);
            
            // 将加载的大小同步到所有配色方案
            const loadedFontSize = this.fontSettings.logo.fontSize;
            const loadedBgSize = this.fontSettings.logo.bgSize;
            Object.keys(this.colorSchemes).forEach(name => {
              if (this.colorSchemes[name].logo) {
                this.colorSchemes[name].logo.fontSize = loadedFontSize;
                this.colorSchemes[name].logo.bgSize = loadedBgSize;
              }
            });
          }
        }
      } catch (error) {
        console.error('从数据库加载配色方案失败:', error);
        // 降级：从localStorage加载
        try {
          Object.keys(this.colorSchemes).forEach(schemeName => {
            const savedScheme = localStorage.getItem('cardImageColorSchemes_' + schemeName);
            if (savedScheme) {
              this.colorSchemes[schemeName] = JSON.parse(savedScheme);
            }
          });
        } catch (e) {
          console.error('从localStorage加载配色方案失败:', e);
        }
      }
    },

    // 保存样式到列表
    saveStyle() {
      if (!this.newStyleName.trim()) {
        alert('请输入样式名称！');
        return;
      }

      // 检查样式名称是否已存在
      const existingIndex = this.savedStyles.findIndex(style => style.name === this.newStyleName.trim());
      
      const style = {
        name: this.newStyleName.trim(),
        fontSettings: JSON.parse(JSON.stringify(this.fontSettings)),
        textPositions: JSON.parse(JSON.stringify(this.textPositions)),
        separatorPosition: JSON.parse(JSON.stringify(this.separatorPosition)),
        separatorColor: this.separatorColor,
        separatorWidth: this.separatorWidth,
        createdAt: new Date().toISOString()
      };

      if (existingIndex !== -1) {
        // 样式已存在，询问是否覆盖
        if (confirm('样式"' + style.name + '"已存在，是否覆盖？')) {
          this.savedStyles[existingIndex] = style;
          this.currentStyleIndex = existingIndex;
        } else {
          return;
        }
      } else {
        // 新样式，添加到列表
        this.savedStyles.push(style);
        this.currentStyleIndex = this.savedStyles.length - 1;
      }

      // 保存到 localStorage
      try {
        localStorage.setItem('cardImageSavedStyles', JSON.stringify(this.savedStyles));
        alert('样式"' + style.name + '"已保存！');
        this.newStyleName = '';
      } catch (error) {
        console.error('保存样式失败:', error);
        alert('保存样式失败，请检查浏览器存储权限！');
        if (existingIndex === -1) {
          this.savedStyles.pop(); // 回滚
        }
      }
    },

    // 覆盖当前模板的颜色方案（位置会同步到所有模板）
    async overwriteCurrentScheme() {
      // 找到当前模板对应的配色方案
      const currentTemplate = this.backgroundTemplates.find(t => t.url === this.cardBackgroundImage);
      if (!currentTemplate || !currentTemplate.colorScheme) {
        alert('当前模板没有对应的配色方案！');
        return;
      }

      const schemeName = currentTemplate.colorScheme;
      if (!confirm(`确定要覆盖"${schemeName}"模板的颜色方案吗？\n位置设置将同步到所有模板。`)) {
        return;
      }

      // 构建配色方案数据（包含颜色和位置）
      const scheme = {
        title: {
          color: this.fontSettings.title.color,
          strokeColor: this.fontSettings.title.strokeColor,
          strokeWidth: this.fontSettings.title.strokeWidth
        },
        batchNumber: {
          color: this.fontSettings.batchNumber.color,
          strokeColor: this.fontSettings.batchNumber.strokeColor,
          strokeWidth: this.fontSettings.batchNumber.strokeWidth
        },
        cardNumber: {
          color: this.fontSettings.cardNumber.color,
          strokeColor: this.fontSettings.cardNumber.strokeColor,
          strokeWidth: this.fontSettings.cardNumber.strokeWidth
        },
        validity: {
          color: this.fontSettings.validity.color,
          strokeColor: this.fontSettings.validity.strokeColor,
          strokeWidth: this.fontSettings.validity.strokeWidth
        },
        website: {
          color: this.fontSettings.website.color,
          strokeColor: this.fontSettings.website.strokeColor,
          strokeWidth: this.fontSettings.website.strokeWidth
        },
        logo: {
          color: this.fontSettings.logo.color,
          fontSize: this.fontSettings.logo.fontSize,
          bgSize: this.fontSettings.logo.bgSize,
          maskShape: this.fontSettings.logo.maskShape
        },
        separator: {
          color: this.separatorColor,
          width: this.separatorWidth
        },
        // 添加位置信息（包含logo位置）
        textPositions: JSON.parse(JSON.stringify(this.textPositions)),
        separatorPosition: JSON.parse(JSON.stringify(this.separatorPosition))
      };

      // 更新本地配色方案
      this.colorSchemes[schemeName] = scheme;

      // 保存到数据库（当前模板的颜色 + 所有模板的位置）
      try {
        // 保存当前模板
        const response = await axios.post('api/card-color-scheme/save/', {
          scheme_name: schemeName,
          scheme: scheme
        }, {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken'
        });

        // 同时更新所有其他模板的位置
        const currentPosition = {
          textPositions: scheme.textPositions,
          separatorPosition: scheme.separatorPosition
        };
        
        // 更新本地所有模板的位置
        Object.keys(this.colorSchemes).forEach(name => {
          if (name !== schemeName && this.colorSchemes[name]) {
            this.colorSchemes[name].textPositions = JSON.parse(JSON.stringify(currentPosition.textPositions));
            this.colorSchemes[name].separatorPosition = JSON.parse(JSON.stringify(currentPosition.separatorPosition));
          }
        });

        // 批量更新数据库中其他模板的位置
        await axios.post('api/card-color-scheme/update-all-positions/', {
          textPositions: currentPosition.textPositions,
          separatorPosition: currentPosition.separatorPosition
        }, {
          withCredentials: true,
          xsrfCookieName: 'csrftoken',
          xsrfHeaderName: 'X-Csrftoken'
        });

        if (response.data.success) {
          alert(`"${schemeName}"模板颜色方案已保存！\n位置已同步到所有模板！`);
        } else {
          alert('保存失败：' + response.data.message);
        }
      } catch (error) {
        console.error('保存配色方案到数据库失败:', error);
        alert('保存失败！');
      }
    },

    // 应用已保存的样式
    applyStyle(style) {
      try {
        this.fontSettings = JSON.parse(JSON.stringify(style.fontSettings));
        this.textPositions = JSON.parse(JSON.stringify(style.textPositions));
        // 确保textPositions.logo存在（兼容旧样式）
        if (!this.textPositions.logo) {
          this.textPositions.logo = { x: 0.15, y: 0.15 };
        }
        this.separatorPosition = JSON.parse(JSON.stringify(style.separatorPosition));
        this.separatorColor = style.separatorColor || '#ffffff';
        this.separatorWidth = style.separatorWidth || 3;

        // 更新当前样式索引
        this.currentStyleIndex = this.savedStyles.indexOf(style);

        // 重新绘制预览
        if (this.cardBackgroundImage) {
          this.drawCardPreview();
        }

        alert('已应用样式"' + style.name + '"！');
      } catch (error) {
        console.error('应用样式失败:', error);
        alert('应用样式失败！');
      }
    },

    // 删除样式
    deleteStyle(index) {
      if (!confirm('确定要删除样式"' + this.savedStyles[index].name + '"吗？')) {
        return;
      }

      this.savedStyles.splice(index, 1);

      // 如果删除的是当前应用的样式，重置索引
      if (this.currentStyleIndex === index) {
        this.currentStyleIndex = -1;
      } else if (this.currentStyleIndex > index) {
        this.currentStyleIndex--;
      }

      // 保存到 localStorage
      try {
        localStorage.setItem('cardImageSavedStyles', JSON.stringify(this.savedStyles));
        alert('样式已删除！');
      } catch (error) {
        console.error('删除样式失败:', error);
        alert('删除样式失败！');
      }
    },

    // 判断是否为当前应用的样式
    isCurrentStyle(style) {
      const index = this.savedStyles.indexOf(style);
      return index === this.currentStyleIndex;
    },

    // 静默恢复默认设置（不显示提示）
    restoreDefaultSettingsSilent() {
      try {
        const savedSettings = localStorage.getItem('cardImageDefaultSettings');

        if (savedSettings) {
          const parsedSettings = JSON.parse(savedSettings);

          // 验证保存的设置是否完整
          const isValidSettings = parsedSettings.fontSettings &&
                                 parsedSettings.fontSettings.title &&
                                 parsedSettings.fontSettings.batchNumber &&
                                 parsedSettings.fontSettings.cardNumber &&
                                 parsedSettings.fontSettings.validity &&
                                 parsedSettings.textPositions &&
                                 parsedSettings.textPositions.title &&
                                 parsedSettings.textPositions.batchNumber &&
                                 parsedSettings.textPositions.cardNumber &&
                                 parsedSettings.textPositions.validity &&
                                 parsedSettings.textPositions.website;

          if (isValidSettings) {
            // 恢复设置
            this.fontSettings = parsedSettings.fontSettings;
            this.textPositions = parsedSettings.textPositions;
            // 确保textPositions.logo存在（兼容旧设置）
            if (!this.textPositions.logo) {
              this.textPositions.logo = { x: 0.15, y: 0.15 };
            }
            this.separatorPosition = parsedSettings.separatorPosition;
            this.separatorColor = parsedSettings.separatorColor || '#ffffff';
            this.separatorWidth = parsedSettings.separatorWidth || 3;

            // 重新绘制预览
            if (this.cardBackgroundImage) {
              this.drawCardPreview();
            }
          } else {
            console.warn('保存的设置不完整，使用默认设置');
            // 清除损坏的设置
            localStorage.removeItem('cardImageDefaultSettings');
          }
        }
      } catch (error) {
        console.error('恢复默认设置失败:', error);
        // 清除可能损坏的设置
        localStorage.removeItem('cardImageDefaultSettings');
      }
    },
    // 处理图片上传
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      
      // 验证文件大小（最大5MB）
      if (file.size > 5 * 1024 * 1024) {
        alert('图片大小不能超过5MB');
        return;
      }
      
      // 读取文件
      const reader = new FileReader();
      reader.onload = (e) => {
        this.cardBackgroundImage = e.target.result;
      };
      reader.readAsDataURL(file);
      
      // 重置文件输入，以便可以再次选择同一文件
      event.target.value = '';
    },
    
    // 移除背景图片
    removeBackgroundImage() {
      this.cardBackgroundImage = null;
    },

    // 加载默认Logo
    loadDefaultLogo() {
      const defaultLogoPath = '/icons/icon-192x192.png';
      const img = new Image();
      img.onload = () => {
        // 将图片转换为base64
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0);
        this.logoImage = canvas.toDataURL('image/png');
        // 如果已有背景图片，重新绘制预览以显示logo
        if (this.cardBackgroundImage) {
          this.drawCardPreview();
        }
      };
      img.onerror = () => {
        console.warn('加载默认Logo失败');
      };
      img.src = defaultLogoPath;
    },

    // 加载默认Logo（返回Promise版本）
    loadDefaultLogoAsync() {
      return new Promise((resolve) => {
        const defaultLogoPath = '/icons/icon-192x192.png';
        const img = new Image();
        img.onload = () => {
          // 将图片转换为base64
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);
          this.logoImage = canvas.toDataURL('image/png');
          resolve(true);
        };
        img.onerror = () => {
          console.warn('加载默认Logo失败');
          resolve(false);
        };
        img.src = defaultLogoPath;
      });
    },

    // 处理Logo上传
    handleLogoUpload(event) {
      const file = event.target.files[0];
      if (!file) return;
      
      // 验证文件大小（最大2MB）
      if (file.size > 2 * 1024 * 1024) {
        alert('Logo图片大小不能超过2MB');
        return;
      }
      
      // 读取文件
      const reader = new FileReader();
      reader.onload = (e) => {
        this.logoImage = e.target.result;
        // 重置logo位置
        this.textPositions.logo = { x: 0.15, y: 0.15 };
        // 重新绘制预览以显示新logo
        if (this.cardBackgroundImage) {
          this.drawCardPreview();
        }
      };
      reader.readAsDataURL(file);
      
      // 重置文件输入
      event.target.value = '';
    },

    // 移除Logo
    removeLogo() {
      this.logoImage = null;
      this.isLogoSelected = false;
      // 重新绘制预览以移除logo
      if (this.cardBackgroundImage) {
        this.drawCardPreview();
      }
    },

    // 绘制卡预览
    drawCardPreview() {
      if (!this.cardBackgroundImage) return;

      const canvas = this.$refs.cardCanvas;
      if (!canvas) return;

      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = () => {
        // 获取图片原始尺寸
        const imgWidth = img.width;
        const imgHeight = img.height;

        // 设置最大限制（预览画布尺寸）
        const maxWidth = 600;
        const maxHeight = 360;

        // 计算缩放比例，保持图片原始比例
        const scaleX = maxWidth / imgWidth;
        const scaleY = maxHeight / imgHeight;
        const scale = Math.min(scaleX, scaleY, 1); // 不超过原始尺寸

        // 设置 Canvas 尺寸与图片比例一致
        canvas.width = Math.floor(imgWidth * scale);
        canvas.height = Math.floor(imgHeight * scale);

        // 清空画布
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        // 绘制图片（占满整个 Canvas）
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        // 添加文字信息
        this.drawCardText(ctx, canvas.width, canvas.height);
      };

      img.src = this.cardBackgroundImage;
    },
    
    // 绘制会员卡文字信息
    drawCardText(ctx, width, height) {
    // 安全检查：确保 fontSettings 和 textPositions 已定义
    if (!this.fontSettings || !this.textPositions) {
      console.error('fontSettings 或 textPositions 未定义');
      return;
    }

    // 将相对位置转换为实际像素位置
    const getX = (relX) => relX * width;
    const getY = (relY) => relY * height;

    // 调试：绘制点击区域（显示可拖拽区域）
    if (this.showHitAreas) {
      this.drawHitAreas(ctx, width, height);
    }

    // 添加标题
    const titleSettings = this.fontSettings.title || {};
    ctx.fillStyle = titleSettings.color || '#ffffff';
    ctx.strokeStyle = titleSettings.strokeColor || '#000000';
    ctx.lineWidth = titleSettings.strokeWidth !== undefined ? titleSettings.strokeWidth : 1;
    ctx.font = `${titleSettings.isBold ? 'bold' : ''} ${titleSettings.isItalic ? 'italic' : ''} ${titleSettings.fontSize || 45}px ${titleSettings.fontFamily || "'Microsoft YaHei', sans-serif"}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle'; // 使用 middle 基线，让 y 坐标在文字中心
    ctx.letterSpacing = (titleSettings.letterSpacing || 5) + 'px';
    const titleX = getX(this.textPositions.title?.x || 0.5);
    const titleY = getY(this.textPositions.title?.y || 0.25);
    const titleText = this.getCardTypeName();
    ctx.fillText(titleText, titleX, titleY);
    ctx.strokeText(titleText, titleX, titleY);

    // 添加分隔线（使用独立的相对位置）
    ctx.strokeStyle = this.separatorColor || '#ffffff';
    ctx.lineWidth = this.separatorWidth || 3;
    ctx.beginPath();
    const separatorY = getY(this.separatorPosition?.y || 0.35);
    ctx.moveTo(width * 0.2, separatorY);
    ctx.lineTo(width * 0.8, separatorY);
    ctx.stroke();

    // 计算卡类型显示
    let validityText = '';
    if (this.cardInfo.validityType === 'custom') {
        validityText = `${this.cardInfo.validDays}天`;
    } else if (this.cardInfo.validityType === 'week') {
        validityText = '周卡';
    } else if (this.cardInfo.validityType === 'month') {
        validityText = '月卡';
    } else if (this.cardInfo.validityType === 'year') {
        validityText = '年卡';
    }

    // 批次号
    const batchNumberSettings = this.fontSettings.batchNumber || {};
    ctx.fillStyle = batchNumberSettings.color || '#ffffff';
    ctx.strokeStyle = batchNumberSettings.strokeColor || '#000000';
    ctx.lineWidth = batchNumberSettings.strokeWidth !== undefined ? batchNumberSettings.strokeWidth : 1;
    ctx.font = `${batchNumberSettings.isBold ? 'bold' : ''} ${batchNumberSettings.isItalic ? 'italic' : ''} ${batchNumberSettings.fontSize || 22}px ${batchNumberSettings.fontFamily || "'Microsoft YaHei', sans-serif"}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.letterSpacing = (batchNumberSettings.letterSpacing || 4) + 'px';
    const batchX = getX(this.textPositions.batchNumber?.x || 0.5);
    const batchY = getY(this.textPositions.batchNumber?.y || 0.45);
    ctx.fillText(`批次号: ${this.cardInfo.batchNumber}`, batchX, batchY);
    ctx.strokeText(`批次号: ${this.cardInfo.batchNumber}`, batchX, batchY);

    // 卡密
    const cardNumberSettings = this.fontSettings.cardNumber || {};
    ctx.fillStyle = cardNumberSettings.color || '#ffffff';
    ctx.strokeStyle = cardNumberSettings.strokeColor || '#000000';
    ctx.lineWidth = cardNumberSettings.strokeWidth !== undefined ? cardNumberSettings.strokeWidth : 1;
    ctx.font = `${cardNumberSettings.isBold ? 'bold' : ''} ${cardNumberSettings.isItalic ? 'italic' : ''} ${cardNumberSettings.fontSize || 22}px ${cardNumberSettings.fontFamily || "'Microsoft YaHei', sans-serif"}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.letterSpacing = (cardNumberSettings.letterSpacing || 4) + 'px';
    const cardX = getX(this.textPositions.cardNumber?.x || 0.5);
    const cardY = getY(this.textPositions.cardNumber?.y || 0.55);
    ctx.fillText(`卡  密: ${this.cardInfo.cardNumber}`, cardX, cardY);
    ctx.strokeText(`卡  密: ${this.cardInfo.cardNumber}`, cardX, cardY);

    // 有效期（周卡/月卡/年卡）- 右对齐
    const validitySettings = this.fontSettings.validity || {};
    ctx.fillStyle = validitySettings.color || '#ffffff';
    ctx.strokeStyle = validitySettings.strokeColor || '#000000';
    ctx.lineWidth = validitySettings.strokeWidth !== undefined ? validitySettings.strokeWidth : 1;
    ctx.font = `${validitySettings.isBold ? 'bold' : ''} ${validitySettings.isItalic ? 'italic' : ''} ${validitySettings.fontSize || 44}px ${validitySettings.fontFamily || "'Microsoft YaHei', sans-serif"}`;
    ctx.textAlign = 'right';  // 右对齐
    ctx.textBaseline = 'middle';
    ctx.letterSpacing = (validitySettings.letterSpacing || 5) + 'px';

    const validityX = getX(this.textPositions.validity?.x || 0.75);
    const validityY = getY(this.textPositions.validity?.y || 0.75);

    ctx.fillText(`${validityText}`, validityX, validityY);
    ctx.strokeText(`${validityText}`, validityX, validityY);

    // 网址
    const websiteSettings = this.fontSettings.website || {};
    ctx.fillStyle = websiteSettings.color || '#ffffff';
    ctx.strokeStyle = websiteSettings.strokeColor || '#000000';
    ctx.lineWidth = websiteSettings.strokeWidth !== undefined ? websiteSettings.strokeWidth : 1;
    ctx.font = `${websiteSettings.isBold ? 'bold' : ''} ${websiteSettings.isItalic ? 'italic' : ''} ${websiteSettings.fontSize || 18}px ${websiteSettings.fontFamily || "'Microsoft YaHei', sans-serif"}`;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.letterSpacing = (websiteSettings.letterSpacing || 2) + 'px';
    
    const websiteX = getX(this.textPositions.website?.x || 0.5);
    const websiteY = getY(this.textPositions.website?.y || 0.88);
    const websiteText = `网址：${this.cardInfo.website || 'yuanbida.net'}`;
    ctx.fillText(websiteText, websiteX, websiteY);
    ctx.strokeText(websiteText, websiteX, websiteY);

    // 重置字间距
    ctx.letterSpacing = '4px';
    
    // 绘制Logo
    if (this.logoImage) {
      this.drawLogo(ctx, width, height);
    }
    },

    // 绘制Logo（支持蒙版）
    drawLogo(ctx, width, height) {
      if (!this.logoImage) return;

      const logoImg = new Image();
      logoImg.src = this.logoImage;

      // 如果图片还没加载完，等待下次绘制
      if (!logoImg.complete) {
        logoImg.onload = () => {
          this.drawCardPreview();
        };
        return;
      }

      // 从fontSettings.logo获取设置（与其他文字统一）
      const logoSettings = this.fontSettings.logo || {};
      const logoPos = this.textPositions.logo || { x: 0.15, y: 0.15 };
      
      const logoX = logoPos.x * width;
      const logoY = logoPos.y * height;
      const imgSize = logoSettings.fontSize || 60; // 图片大小
      const bgSize = logoSettings.bgSize || 60; // 背景色大小
      const bgColor = logoSettings.color || '#ffffff'; // 背景色
      const maskShape = logoSettings.maskShape || 'circle'; // 蒙版形状

      ctx.save();

      // 计算背景和绘制的偏移量（使背景居中于图片）
      const bgOffsetX = (imgSize - bgSize) / 2;
      const bgOffsetY = (imgSize - bgSize) / 2;
      const bgX = logoX + bgOffsetX;
      const bgY = logoY + bgOffsetY;

      // 绘制背景色（在蒙版之前）
      if (bgColor) {
        ctx.fillStyle = bgColor;
        if (maskShape === 'circle') {
          ctx.beginPath();
          ctx.arc(bgX + bgSize / 2, bgY + bgSize / 2, bgSize / 2, 0, Math.PI * 2);
          ctx.closePath();
          ctx.fill();
        } else if (maskShape === 'square') {
          const radius = bgSize * 0.1;
          ctx.beginPath();
          ctx.moveTo(bgX + radius, bgY);
          ctx.lineTo(bgX + bgSize - radius, bgY);
          ctx.quadraticCurveTo(bgX + bgSize, bgY, bgX + bgSize, bgY + radius);
          ctx.lineTo(bgX + bgSize, bgY + bgSize - radius);
          ctx.quadraticCurveTo(bgX + bgSize, bgY + bgSize, bgX + bgSize - radius, bgY + bgSize);
          ctx.lineTo(bgX + radius, bgY + bgSize);
          ctx.quadraticCurveTo(bgX, bgY + bgSize, bgX, bgY + bgSize - radius);
          ctx.lineTo(bgX, bgY + radius);
          ctx.quadraticCurveTo(bgX, bgY, bgX + radius, bgY);
          ctx.closePath();
          ctx.fill();
        } else {
          ctx.fillRect(bgX, bgY, bgSize, bgSize);
        }
      }

      // 应用蒙版（使用背景色大小，与背景色一样大）
      if (maskShape === 'circle') {
        // 圆形蒙版
        ctx.beginPath();
        ctx.arc(bgX + bgSize / 2, bgY + bgSize / 2, bgSize / 2, 0, Math.PI * 2);
        ctx.closePath();
        ctx.clip();
      } else if (maskShape === 'square') {
        // 方形蒙版（圆角）
        const radius = bgSize * 0.1; // 圆角半径
        ctx.beginPath();
        ctx.moveTo(bgX + radius, bgY);
        ctx.lineTo(bgX + bgSize - radius, bgY);
        ctx.quadraticCurveTo(bgX + bgSize, bgY, bgX + bgSize, bgY + radius);
        ctx.lineTo(bgX + bgSize, bgY + bgSize - radius);
        ctx.quadraticCurveTo(bgX + bgSize, bgY + bgSize, bgX + bgSize - radius, bgY + bgSize);
        ctx.lineTo(bgX + radius, bgY + bgSize);
        ctx.quadraticCurveTo(bgX, bgY + bgSize, bgX, bgY + bgSize - radius);
        ctx.lineTo(bgX, bgY + radius);
        ctx.quadraticCurveTo(bgX, bgY, bgX + radius, bgY);
        ctx.closePath();
        ctx.clip();
      }

      // 绘制Logo图片
      ctx.drawImage(logoImg, logoX, logoY, imgSize, imgSize);
      
      ctx.restore();
      
      // 如果Logo被选中（或正在拖拽/调整大小），绘制边框和调整手柄
      if (this.isLogoSelected || this.isDraggingLogo || this.isResizingLogo) {
        ctx.save();
        ctx.strokeStyle = '#409eff';
        ctx.lineWidth = 2;
        // 选中边框使用背景色大小（与蒙版一致）
        if (maskShape === 'circle') {
          ctx.beginPath();
          ctx.arc(bgX + bgSize / 2, bgY + bgSize / 2, bgSize / 2 + 2, 0, Math.PI * 2);
          ctx.stroke();
        } else if (maskShape === 'square') {
          ctx.strokeRect(bgX - 2, bgY - 2, bgSize + 4, bgSize + 4);
        } else {
          ctx.strokeRect(bgX - 2, bgY - 2, bgSize + 4, bgSize + 4);
        }

        // 绘制四个角落的调整手柄（使用图片大小位置，方便调整）
        const handleSize = this.logoResizeHandleSize;
        ctx.fillStyle = '#409eff';
        const corners = [
          { x: logoX, y: logoY }, // nw
          { x: logoX + imgSize, y: logoY }, // ne
          { x: logoX, y: logoY + imgSize }, // sw
          { x: logoX + imgSize, y: logoY + imgSize } // se
        ];
        corners.forEach(corner => {
          ctx.fillRect(corner.x - handleSize / 2, corner.y - handleSize / 2, handleSize, handleSize);
        });

        ctx.restore();
      }
    },

    // 绘制点击检测区域（用于调试）
    drawHitAreas(ctx, width, height) {
      // 保存当前状态
      ctx.save();

      // 绘制分隔线的点击区域
      const separatorY = this.separatorPosition?.y || 0.35;
      const separatorHitHeight = 0.03;
      const isSeparatorSelected = this.selectedTextType === 'separator';

      const sepTop = (separatorY - separatorHitHeight / 2) * height;
      const sepBottom = (separatorY + separatorHitHeight / 2) * height;
      const sepLeft = 0.15 * width;
      const sepRight = 0.85 * width;

      // 绘制分隔线点击区域
      ctx.fillStyle = isSeparatorSelected ? 'rgba(0, 255, 255, 0.4)' : 'rgba(0, 255, 255, 0.2)'; // 青色
      ctx.fillRect(sepLeft, sepTop, sepRight - sepLeft, sepBottom - sepTop);
      ctx.strokeStyle = isSeparatorSelected ? 'rgba(0, 255, 255, 0.9)' : 'rgba(0, 255, 255, 0.6)';
      ctx.lineWidth = isSeparatorSelected ? 3 : 1;
      ctx.strokeRect(sepLeft, sepTop, sepRight - sepLeft, sepBottom - sepTop);

      // 绘制分隔线中心点
      ctx.fillStyle = isSeparatorSelected ? 'rgba(255, 0, 0, 1)' : 'rgba(255, 0, 0, 0.5)';
      ctx.beginPath();
      ctx.arc(width * 0.5, separatorY * height, isSeparatorSelected ? 6 : 4, 0, Math.PI * 2);
      ctx.fill();

      // 绘制每个文字的点击区域
      for (const [textType, position] of Object.entries(this.textPositions)) {
        const fontSize = this.fontSettings[textType]?.fontSize || 22;
        const fontHeightRel = (fontSize * 1.2) / height;

        let textContent = '';
        if (textType === 'title') textContent = this.getCardTypeName();
        else if (textType === 'batchNumber') textContent = `批次号: ${this.cardInfo.batchNumber || ''}`;
        else if (textType === 'cardNumber') textContent = `卡  密: ${this.cardInfo.cardNumber || ''}`;
        else if (textType === 'validity') textContent = '周卡';

        const charWidthRel = (fontSize * 0.8) / width;
        const textWidthRel = textContent.length * charWidthRel;
        const paddingX = charWidthRel * 2;
        const paddingY = fontHeightRel * 0.8;

        const hitLeft = (position.x - textWidthRel / 2 - paddingX) * width;
        const hitRight = (position.x + textWidthRel / 2 + paddingX) * width;
        const hitTop = (position.y - fontHeightRel / 2 - paddingY) * height;
        const hitBottom = (position.y + fontHeightRel / 2 + paddingY) * height;

        // 如果是当前选中的文字，使用高亮颜色
        const isSelected = this.selectedTextType === textType;

        // 绘制半透明矩形表示点击区域
        ctx.fillStyle = isSelected ? 'rgba(0, 255, 0, 0.4)' : 'rgba(255, 255, 0, 0.2)'; // 选中为绿色，其他为淡黄色
        ctx.fillRect(hitLeft, hitTop, hitRight - hitLeft, hitBottom - hitTop);

        // 绘制边框
        ctx.strokeStyle = isSelected ? 'rgba(0, 255, 0, 0.9)' : 'rgba(255, 255, 0, 0.6)';
        ctx.lineWidth = isSelected ? 3 : 1;
        ctx.strokeRect(hitLeft, hitTop, hitRight - hitLeft, hitBottom - hitTop);

        // 绘制中心点
        ctx.fillStyle = isSelected ? 'rgba(255, 0, 0, 1)' : 'rgba(255, 0, 0, 0.5)';
        ctx.beginPath();
        ctx.arc(position.x * width, position.y * height, isSelected ? 6 : 4, 0, Math.PI * 2);
        ctx.fill();
      }

      // 恢复状态
      ctx.restore();
    },

    // 生成会员卡图片
    async generateCardImage() {
      const cardTypeName = this.getCardTypeName();
      if (!this.cardBackgroundImage || !this.cardInfo.batchNumber || !this.cardInfo.cardNumber) {
        alert(`请填写完整的${cardTypeName}信息！`);
        return;
      }

      // 确保预览已更新
      this.drawCardPreview();

      const canvas = this.$refs.cardCanvas;
      if (!canvas) return;

      try {
        // 复制卡片信息到剪切板
        // 计算实际有效期天数
        let validityDays = this.cardInfo.validityType;
        let validityText = '';
        if (this.cardInfo.validityType === 'week') {
          validityDays = 7;
          validityText = '周卡(7天)';
        } else if (this.cardInfo.validityType === 'month') {
          validityDays = 30;
          validityText = '月卡(30天)';
        } else if (this.cardInfo.validityType === 'quarter') {
          validityDays = 90;
          validityText = '季卡(90天)';
        } else if (this.cardInfo.validityType === 'year') {
          validityDays = 365;
          validityText = '年卡(365天)';
        } else {
          validityDays = parseInt(this.cardInfo.validityType) || this.cardInfo.validDays;
          validityText = validityDays + '天';
        }
        
        const cardInfoText = `${cardTypeName}
批次号：${this.cardInfo.batchNumber}
卡密：${this.cardInfo.cardNumber}
有效期：${validityText}
网址：${this.cardInfo.website || 'www.yuanbida.net'}`;
        
        try {
          await navigator.clipboard.writeText(cardInfoText);
        } catch (clipError) {
          // 降级方案：使用传统方式复制
          const textArea = document.createElement('textarea');
          textArea.value = cardInfoText;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
        }

        // 将Canvas转换为图片并下载
        const link = document.createElement('a');
        link.download = `${cardTypeName}_${this.cardInfo.batchNumber}_${this.cardInfo.cardNumber}.png`;
        link.href = canvas.toDataURL();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        // 更新数据库中的图片制作状态
        try {
          const response = await axios.post('api/update-card-image-status/', {
            card_number: this.cardInfo.cardNumber,
            image_made: true
          }, {
            withCredentials: true,
            xsrfCookieName: 'csrftoken',
            xsrfHeaderName: 'X-Csrftoken',
          });

          if (response.data.success) {
            const cardTypeName = this.getCardTypeName();
            alert(`${cardTypeName}图片已生成并下载！\n卡片信息已复制到剪切板！\n图片制作状态已更新为：已制作`);
            // 通知父组件更新成功，可以刷新列表
            this.$emit('image-made-success', this.cardInfo.cardNumber);
            // 自动关闭弹窗
            this.$emit('close');
          } else {
            const cardTypeName = this.getCardTypeName();
            alert(`${cardTypeName}图片已生成并下载！\n卡片信息已复制到剪切板！\n但图片制作状态更新失败：` + response.data.message);
          }
        } catch (apiError) {
          console.error('更新图片制作状态失败:', apiError);
          const cardTypeName = this.getCardTypeName();
          // 区分不同类型的错误
          let errorMsg = `${cardTypeName}图片已生成并下载！\n卡片信息已复制到剪切板！`;
          if (apiError.response) {
            if (apiError.response.status === 404) {
              errorMsg += `\n但${cardTypeName}不存在，请检查卡号是否正确`;
            } else if (apiError.response.status === 403) {
              errorMsg += `\n但您没有权限更新${cardTypeName}状态`;
            } else if (apiError.response.status === 401) {
              errorMsg += '\n但您未登录，请先登录';
            } else {
              errorMsg += '\n但图片制作状态更新失败';
            }
          } else {
            errorMsg += '\n但图片制作状态更新失败，请检查网络连接';
          }
          alert(errorMsg);
        }
      } catch (error) {
        console.error('生成图片失败:', error);
        const cardTypeName = this.getCardTypeName();
        alert(`生成${cardTypeName}图片失败：` + error.message);
      }
    },
    
    // 清空表单
    clearForm() {
      this.cardBackgroundImage = null;
      this.cardInfo = {
        batchNumber: '',
        cardNumber: '',
        validityType: 'month',
        validDays: 30
      };
    },
    // 保存为默认设置
   // 保存为默认设置
    saveDefaultSettings() {
  const defaultSettings = {
    fontSettings: this.fontSettings,
    textPositions: this.textPositions,
    separatorPosition: this.separatorPosition
  };
  
  try {
    localStorage.setItem('cardImageDefaultSettings', JSON.stringify(defaultSettings));
    alert('默认设置已保存！');
  } catch (error) {
    console.error('保存默认设置失败:', error);
    alert('保存默认设置失败，请检查浏览器存储权限！');
  }
    },
    
    // 恢复默认设置
    restoreDefaultSettings() {
      try {
        // 从localStorage获取保存的设置
        const savedSettings = localStorage.getItem('cardImageDefaultSettings');

        if (savedSettings) {
          const parsedSettings = JSON.parse(savedSettings);

          // 恢复设置
          this.fontSettings = parsedSettings.fontSettings;
          this.textPositions = parsedSettings.textPositions;
          // 确保textPositions.logo存在（兼容旧设置）
          if (!this.textPositions.logo) {
            this.textPositions.logo = { x: 0.15, y: 0.15 };
          }
          this.separatorPosition = parsedSettings.separatorPosition;
          this.separatorColor = parsedSettings.separatorColor || '#ffffff';
          this.separatorWidth = parsedSettings.separatorWidth || 3;

          // 重新绘制预览
          this.drawCardPreview();

          alert('默认设置已恢复！');
        } else {
          alert('没有找到保存的默认设置！');
        }
      } catch (error) {
        console.error('恢复默认设置失败:', error);
        alert('恢复默认设置失败！');
      }
    },
    // 添加鼠标和触摸事件监听器
    addMouseEvents() {
    const canvas = this.$refs.cardCanvas;
    if (!canvas) return;

    // 移除旧的事件监听器（如果存在）
    this.removeMouseEvents();

    // 绑定 this
    this.boundHandleMouseDown = this.handleMouseDown.bind(this);
    this.boundHandleMouseMove = this.handleMouseMove.bind(this);
    this.boundHandleMouseUp = this.handleMouseUp.bind(this);
    this.boundHandleMouseLeave = this.handleMouseLeave.bind(this);
    this.boundHandleTouchStart = this.handleTouchStart.bind(this);
    this.boundHandleTouchMove = this.handleTouchMove.bind(this);
    this.boundHandleTouchEnd = this.handleTouchEnd.bind(this);

    // 鼠标按下事件
    canvas.addEventListener('mousedown', this.boundHandleMouseDown);

    // 鼠标移动事件（绑定到 document 以防止鼠标移出 canvas 时丢失）
    document.addEventListener('mousemove', this.boundHandleMouseMove);

    // 鼠标释放事件（绑定到 document 以防止鼠标移出 canvas 时丢失）
    document.addEventListener('mouseup', this.boundHandleMouseUp);

    // 鼠标离开事件
    canvas.addEventListener('mouseleave', this.boundHandleMouseLeave);

    // 触摸事件（支持移动端）
    canvas.addEventListener('touchstart', this.boundHandleTouchStart, { passive: false });
    document.addEventListener('touchmove', this.boundHandleTouchMove, { passive: false });
    document.addEventListener('touchend', this.boundHandleTouchEnd);
    document.addEventListener('touchcancel', this.boundHandleTouchEnd);
    },

    // 移除鼠标和触摸事件监听器
    removeMouseEvents() {
      const canvas = this.$refs.cardCanvas;
      if (canvas && this.boundHandleMouseDown) {
        canvas.removeEventListener('mousedown', this.boundHandleMouseDown);
        document.removeEventListener('mousemove', this.boundHandleMouseMove);
        document.removeEventListener('mouseup', this.boundHandleMouseUp);
        canvas.removeEventListener('mouseleave', this.boundHandleMouseLeave);
      }
      if (canvas && this.boundHandleTouchStart) {
        canvas.removeEventListener('touchstart', this.boundHandleTouchStart);
        document.removeEventListener('touchmove', this.boundHandleTouchMove);
        document.removeEventListener('touchend', this.boundHandleTouchEnd);
        document.removeEventListener('touchcancel', this.boundHandleTouchEnd);
      }
    },

    // 处理鼠标离开事件
    handleMouseLeave() {
      // 如果正在拖拽，不停止拖拽（让用户可以继续在外面拖拽）
      // 只恢复光标样式
      const canvas = this.$refs.cardCanvas;
      if (canvas && !this.isDragging) {
        canvas.style.cursor = 'default';
      }
    },

    // 处理触摸开始事件
    handleTouchStart(event) {
      if (event.touches.length !== 1) return;
      const touch = event.touches[0];
      // 创建模拟鼠标事件对象
      const mouseEvent = {
        clientX: touch.clientX,
        clientY: touch.clientY,
        preventDefault: () => event.preventDefault()
      };
      this.handleMouseDown(mouseEvent);
    },

    // 处理触摸移动事件
    handleTouchMove(event) {
      if (event.touches.length !== 1) return;
      const touch = event.touches[0];
      // 创建模拟鼠标事件对象
      const mouseEvent = {
        clientX: touch.clientX,
        clientY: touch.clientY,
        preventDefault: () => event.preventDefault()
      };
      this.handleMouseMove(mouseEvent);
    },

    // 处理触摸结束事件
    handleTouchEnd(event) {
      this.handleMouseUp(event);
    },

    // 保存当前文字位置
    saveCurrentPositions() {
      try {
        const savedSettings = localStorage.getItem('cardImageDefaultSettings');
        let settings = savedSettings ? JSON.parse(savedSettings) : {};

        // 更新位置设置
        settings.textPositions = this.textPositions;
        settings.separatorPosition = this.separatorPosition;

        localStorage.setItem('cardImageDefaultSettings', JSON.stringify(settings));
        console.log('文字位置和分隔线位置已保存');
      } catch (error) {
        console.error('保存位置失败:', error);
      }
    },

    // 处理鼠标按下事件
    handleMouseDown(event) {
    const canvas = this.$refs.cardCanvas;
    if (!canvas) return;

    // 获取鼠标在画布上的坐标（考虑 Canvas 的 CSS 显示尺寸与实际尺寸的比例）
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    const x = (event.clientX - rect.left) * scaleX;
    const y = (event.clientY - rect.top) * scaleY;

    // 转换为相对坐标
    const relX = x / canvas.width;
    const relY = y / canvas.height;

    // 检查是否按下了Shift键
    const isShiftPressed = event.shiftKey;

      // 检查Logo相关操作
      if (this.logoImage) {
        const logoSettings = this.fontSettings.logo || {};
        const logoSize = logoSettings.fontSize || 60;
        const logoPos = this.textPositions.logo || { x: 0.15, y: 0.15 };
        const logoRelSize = logoSize / canvas.width;
        const logoRelHeight = logoSize / canvas.height;
        const handleRelSize = this.logoResizeHandleSize / canvas.width;
        const handleRelHeight = this.logoResizeHandleSize / canvas.height;

        // 检查四个角落 (se, sw, ne, nw)
        const corners = [
          { name: 'se', x: logoPos.x + logoRelSize, y: logoPos.y + logoRelHeight },
          { name: 'sw', x: logoPos.x, y: logoPos.y + logoRelHeight },
          { name: 'ne', x: logoPos.x + logoRelSize, y: logoPos.y },
          { name: 'nw', x: logoPos.x, y: logoPos.y }
        ];

      // 如果Logo已选中，检查是否点击了角落调整手柄
      if (this.isLogoSelected) {
        for (const corner of corners) {
          if (
            Math.abs(relX - corner.x) <= handleRelSize &&
            Math.abs(relY - corner.y) <= handleRelHeight
          ) {
            this.isResizingLogo = true;
            this.resizeCorner = corner.name;
            this.dragOffset = { x: relX, y: relY };
            // 确保textPositions.logo存在
            if (!this.textPositions.logo) {
              this.textPositions.logo = { x: 0.15, y: 0.15 };
            }
            this.initialPosition = {
              x: this.textPositions.logo.x,
              y: this.textPositions.logo.y,
              size: this.fontSettings.logo.fontSize
            };
            canvas.style.cursor = corner.name === 'se' || corner.name === 'nw' ? 'nwse-resize' : 'nesw-resize';
            event.preventDefault();
            this.drawCardPreview();
            return;
          }
        }
      }

        // 检查是否在Logo区域内（点击选中或拖拽）
        if (
          relX >= logoPos.x - 0.02 &&
          relX <= logoPos.x + logoRelSize + 0.02 &&
          relY >= logoPos.y - 0.02 &&
          relY <= logoPos.y + logoRelHeight + 0.02
        ) {
          // 如果Logo未选中，先选中它
          if (!this.isLogoSelected) {
            this.isLogoSelected = true;
            this.selectedTextType = 'logo'; // 设置选中的文字类型为logo
            event.preventDefault();
            this.drawCardPreview();
            return;
          }
          // 如果已选中，开始拖拽
          this.isDraggingLogo = true;
          this.currentDraggedElement = 'text';
          this.currentDraggedText = 'logo';
          this.dragOffset = {
            x: relX - logoPos.x,
            y: relY - logoPos.y
          };
          canvas.style.cursor = 'move';
          event.preventDefault();
          this.drawCardPreview();
          return;
        }

        // 点击Logo区域外，取消选中
        if (this.isLogoSelected) {
          this.isLogoSelected = false;
          this.selectedTextType = null;
          this.drawCardPreview();
        }
      }

    // 先检查是否点击了分隔线（分隔线检测优先）
    const separatorHitHeight = 0.03; // 分隔线点击区域高度（相对值）
    if (
      relY >= this.separatorPosition.y - separatorHitHeight / 2 &&
      relY <= this.separatorPosition.y + separatorHitHeight / 2 &&
      relX >= 0.15 && relX <= 0.85 // 分隔线水平范围
    ) {
      // 取消Logo选中
      if (this.isLogoSelected) {
        this.isLogoSelected = false;
      }
      this.isDragging = true;
      this.currentDraggedElement = 'separator';
      this.currentDraggedText = null;
      this.selectedTextType = 'separator'; // 记录选中的是分隔线
      this.showHitAreas = true;
      this.dragOffset = {
        x: 0,
        y: relY - this.separatorPosition.y
      };
      this.isShiftPressed = isShiftPressed; // 记录Shift键状态
      canvas.style.cursor = isShiftPressed ? 'ns-resize' : 'move';
      event.preventDefault();
      this.drawCardPreview();
      return;
    }

    // 检查是否点击了某个文字（使用以 position.y 为中心的区域）
    for (const [textType, position] of Object.entries(this.textPositions)) {
        // 获取字体大小
        const fontSize = this.fontSettings[textType]?.fontSize || 22;
        // 计算字体在画布上的相对高度
        const fontHeightRel = (fontSize * 1.2) / canvas.height;
        // 估算文字宽度
        let textContent = '';
        if (textType === 'title') textContent = this.getCardTypeName();
        else if (textType === 'batchNumber') textContent = `批次号: ${this.cardInfo.batchNumber || ''}`;
        else if (textType === 'cardNumber') textContent = `卡  密: ${this.cardInfo.cardNumber || ''}`;
        else if (textType === 'validity') textContent = '周卡';

        const charWidthRel = (fontSize * 0.8) / canvas.width;
        const textWidthRel = textContent.length * charWidthRel;

        // 创建文字的碰撞检测区域（以 position.y 为中心）
        const paddingX = charWidthRel * 2;
        const paddingY = fontHeightRel * 0.8;

        const hitLeft = position.x - textWidthRel / 2 - paddingX;
        const hitRight = position.x + textWidthRel / 2 + paddingX;
        // 以 position.y 为中心，而不是以基线为准
        const hitTop = position.y - fontHeightRel / 2 - paddingY;
        const hitBottom = position.y + fontHeightRel / 2 + paddingY;

        // 检查鼠标是否在文字区域内
        if (
        relX >= hitLeft &&
        relX <= hitRight &&
        relY >= hitTop &&
        relY <= hitBottom
        ) {
        // 取消Logo选中
        if (this.isLogoSelected) {
          this.isLogoSelected = false;
        }
        this.isDragging = true;
        this.currentDraggedElement = 'text';
        this.currentDraggedText = textType;
        this.selectedTextType = textType; // 记录选中的文字类型
        this.showHitAreas = true; // 显示点击区域
        // 记录相对于文字位置的偏移量
        this.dragOffset = {
          x: relX - position.x,
          y: relY - position.y
        };
        this.isShiftPressed = isShiftPressed; // 记录Shift键状态
        this.initialPosition = { x: position.x, y: position.y }; // 记录初始位置，用于判断移动方向
        canvas.style.cursor = 'move';
        // 阻止默认行为，避免选中文本
        event.preventDefault();
        // 立即重绘以显示选中的区域
        this.drawCardPreview();
        break;
        }
    }
    },
    // 处理鼠标移动事件
    handleMouseMove(event) {
    // 处理Logo调整大小
    if (this.isResizingLogo && this.resizeCorner) {
      const canvas = this.$refs.cardCanvas;
      if (!canvas) return;

      const rect = canvas.getBoundingClientRect();
      const scaleX = canvas.width / rect.width;
      const scaleY = canvas.height / rect.height;
      const x = (event.clientX - rect.left) * scaleX;
      const y = (event.clientY - rect.top) * scaleY;
      const relX = x / canvas.width;
      const relY = y / canvas.height;

      // 计算新的尺寸
      const initialSize = this.initialPosition.size / canvas.width;
      let newSize, newX, newY;

      switch (this.resizeCorner) {
        case 'se': // 右下角 - 保持左上角不动
          newSize = Math.max(20 / canvas.width, Math.min(0.5, relX - this.initialPosition.x));
          newSize = Math.max(20 / canvas.width, Math.min(0.5, relY - this.initialPosition.y));
          newX = this.initialPosition.x;
          newY = this.initialPosition.y;
          break;
        case 'sw': // 左下角 - 保持右上角不动
          newSize = Math.max(20 / canvas.width, Math.min(0.5, this.initialPosition.x + initialSize - relX));
          newSize = Math.max(20 / canvas.width, Math.min(0.5, relY - this.initialPosition.y));
          newX = this.initialPosition.x + initialSize - newSize;
          newY = this.initialPosition.y;
          break;
        case 'ne': // 右上角 - 保持左下角不动
          newSize = Math.max(20 / canvas.width, Math.min(0.5, relX - this.initialPosition.x));
          newSize = Math.max(20 / canvas.width, Math.min(0.5, this.initialPosition.y + initialSize - relY));
          newX = this.initialPosition.x;
          newY = this.initialPosition.y + initialSize - newSize;
          break;
        case 'nw': // 左上角 - 保持右下角不动
          newSize = Math.max(20 / canvas.width, Math.min(0.5, this.initialPosition.x + initialSize - relX));
          newSize = Math.max(20 / canvas.width, Math.min(0.5, this.initialPosition.y + initialSize - relY));
          newX = this.initialPosition.x + initialSize - newSize;
          newY = this.initialPosition.y + initialSize - newSize;
          break;
      }

      // 更新Logo大小和位置（使用fontSettings和textPositions）
      this.fontSettings.logo.fontSize = Math.round(newSize * canvas.width);
      this.textPositions.logo.x = newX;
      this.textPositions.logo.y = newY;

      requestAnimationFrame(() => {
        this.drawCardPreview();
      });
      event.preventDefault();
      return;
    }

    // 处理Logo拖拽
    if (this.isDraggingLogo) {
      const canvas = this.$refs.cardCanvas;
      if (!canvas) return;

      const rect = canvas.getBoundingClientRect();
      const scaleX = canvas.width / rect.width;
      const scaleY = canvas.height / rect.height;
      const x = (event.clientX - rect.left) * scaleX;
      const y = (event.clientY - rect.top) * scaleY;
      const relX = x / canvas.width;
      const relY = y / canvas.height;

      // 更新Logo位置
      // 确保textPositions.logo存在
      if (!this.textPositions.logo) {
        this.textPositions.logo = { x: 0.15, y: 0.15 };
      }
      this.textPositions.logo.x = Math.max(0, Math.min(1 - this.fontSettings.logo.fontSize / canvas.width, relX - this.dragOffset.x));
      this.textPositions.logo.y = Math.max(0, Math.min(1 - this.fontSettings.logo.fontSize / canvas.height, relY - this.dragOffset.y));

      requestAnimationFrame(() => {
        this.drawCardPreview();
      });
      event.preventDefault();
      return;
    }

    if (!this.isDragging) {
      // 即使没有拖拽，也更新鼠标样式以指示可拖拽区域
      const canvas = this.$refs.cardCanvas;
      if (!canvas) return;

      const rect = canvas.getBoundingClientRect();
      const scaleX = canvas.width / rect.width;
      const scaleY = canvas.height / rect.height;
      const x = (event.clientX - rect.left) * scaleX;
      const y = (event.clientY - rect.top) * scaleY;
      const relX = x / canvas.width;
      const relY = y / canvas.height;

      // 检查鼠标是否在可拖拽区域内
      let isOverDraggable = false;
      const isShiftPressed = event.shiftKey;

      // 检查是否在Logo区域或角落调整手柄
      if (this.logoImage) {
        const logoSettings = this.fontSettings.logo || {};
        const logoPos = this.textPositions.logo || { x: 0.15, y: 0.15 };
        const logoSize = logoSettings.fontSize || 60;
        const logoRelSize = logoSize / canvas.width;
        const logoRelHeight = logoSize / canvas.height;
        const handleRelSize = this.logoResizeHandleSize / canvas.width;
        const handleRelHeight = this.logoResizeHandleSize / canvas.height;

        // 检查四个角落（仅当Logo被选中时）
        if (this.isLogoSelected) {
          const corners = [
            { name: 'se', x: logoPos.x + logoRelSize, y: logoPos.y + logoRelHeight },
            { name: 'sw', x: logoPos.x, y: logoPos.y + logoRelHeight },
            { name: 'ne', x: logoPos.x + logoRelSize, y: logoPos.y },
            { name: 'nw', x: logoPos.x, y: logoPos.y }
          ];

          let isOverResizeHandle = false;
          for (const corner of corners) {
            if (
              Math.abs(relX - corner.x) <= handleRelSize &&
              Math.abs(relY - corner.y) <= handleRelHeight
            ) {
              isOverResizeHandle = true;
              canvas.style.cursor = corner.name === 'se' || corner.name === 'nw' ? 'nwse-resize' : 'nesw-resize';
              break;
            }
          }

          if (isOverResizeHandle) {
            return; // 在角落，不检查其他区域
          }
        }

        // 检查是否在Logo区域内
        if (
          relX >= logoPos.x - 0.02 &&
          relX <= logoPos.x + logoRelSize + 0.02 &&
          relY >= logoPos.y - 0.02 &&
          relY <= logoPos.y + logoRelHeight + 0.02
        ) {
          isOverDraggable = true;
        }
      }

      // 检查是否在分隔线区域
      const separatorHitHeight = 0.03;
      if (
        relY >= this.separatorPosition.y - separatorHitHeight / 2 &&
        relY <= this.separatorPosition.y + separatorHitHeight / 2 &&
        relX >= 0.15 && relX <= 0.85
      ) {
        isOverDraggable = true;
      }

      // 检查是否在文字区域
      if (!isOverDraggable) {
        for (const [textType, position] of Object.entries(this.textPositions)) {
          const fontSize = this.fontSettings[textType]?.fontSize || 22;
          const fontHeightRel = (fontSize * 1.2) / canvas.height;

          let textContent = '';
          if (textType === 'title') textContent = this.getCardTypeName();
          else if (textType === 'batchNumber') textContent = `批次号: ${this.cardInfo.batchNumber || ''}`;
          else if (textType === 'cardNumber') textContent = `卡  密: ${this.cardInfo.cardNumber || ''}`;
          else if (textType === 'validity') textContent = '周卡';

          const charWidthRel = (fontSize * 0.8) / canvas.width;
          const textWidthRel = textContent.length * charWidthRel;
          const paddingX = charWidthRel * 2;
          const paddingY = fontHeightRel * 0.8;

          const hitLeft = position.x - textWidthRel / 2 - paddingX;
          const hitRight = position.x + textWidthRel / 2 + paddingX;
          const hitTop = position.y - fontHeightRel / 2 - paddingY;
          const hitBottom = position.y + fontHeightRel / 2 + paddingY;

          if (
            relX >= hitLeft &&
            relX <= hitRight &&
            relY >= hitTop &&
            relY <= hitBottom
          ) {
            isOverDraggable = true;
            break;
          }
        }
      }
      // 根据Shift键状态改变光标样式
      if (isShiftPressed && isOverDraggable) {
        canvas.style.cursor = 'crosshair';
      } else {
        canvas.style.cursor = isOverDraggable ? 'move' : 'default';
      }
      return;
    }

    const canvas = this.$refs.cardCanvas;
    if (!canvas) return;

    // 获取鼠标在画布上的坐标（考虑 Canvas 的 CSS 显示尺寸与实际尺寸的比例）
    const rect = canvas.getBoundingClientRect();
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;
    const x = (event.clientX - rect.left) * scaleX;
    const y = (event.clientY - rect.top) * scaleY;

    // 转换为相对坐标
    const relX = x / canvas.width;
    const relY = y / canvas.height;

    // 根据拖拽的元素类型更新位置
    if (this.currentDraggedElement === 'separator') {
      // 分隔线只能垂直移动，Shift键不影响
      this.separatorPosition.y = Math.max(0.1, Math.min(0.9, relY - this.dragOffset.y));
      // 使用 requestAnimationFrame 优化性能
      requestAnimationFrame(() => {
        this.drawCardPreview();
      });
    } else if (this.currentDraggedElement === 'text' && this.currentDraggedText) {
      // 获取当前位置
      const currentPos = this.textPositions[this.currentDraggedText];
      
      // 计算新位置，考虑锁定状态
      let newX, newY;
      
      if (this.isShiftPressed) {
        // Shift键按下：只允许水平或垂直移动
        const deltaX = relX - this.dragOffset.x - this.initialPosition.x;
        const deltaY = relY - this.dragOffset.y - this.initialPosition.y;

        // 判断移动方向：水平或垂直
        if (!this.dragDirection) {
          if (Math.abs(deltaX) > Math.abs(deltaY)) {
            this.dragDirection = 'horizontal';
          } else {
            this.dragDirection = 'vertical';
          }
        }

        // 根据方向和锁定状态约束移动
        if (this.dragDirection === 'horizontal') {
          // 水平移动，检查横向锁定
          newX = this.lockHorizontal ? currentPos.x : Math.max(0.05, Math.min(0.95, relX - this.dragOffset.x));
          newY = this.lockVertical ? currentPos.y : this.initialPosition.y;
        } else {
          // 垂直移动，检查纵向锁定
          newX = this.lockHorizontal ? this.initialPosition.x : currentPos.x;
          newY = this.lockVertical ? currentPos.y : Math.max(0.05, Math.min(0.95, relY - this.dragOffset.y));
        }
      } else {
        // 正常拖动：考虑锁定状态
        newX = this.lockHorizontal ? currentPos.x : Math.max(0.05, Math.min(0.95, relX - this.dragOffset.x));
        newY = this.lockVertical ? currentPos.y : Math.max(0.05, Math.min(0.95, relY - this.dragOffset.y));
        this.dragDirection = null;
      }
      
      // 更新位置
      this.textPositions[this.currentDraggedText] = { x: newX, y: newY };
      
      // 使用 requestAnimationFrame 优化性能
      requestAnimationFrame(() => {
        this.drawCardPreview();
      });
    }

    // 阻止默认行为
    event.preventDefault();
    },

    // 处理鼠标释放事件
    handleMouseUp() {
    // 处理Logo调整大小结束
    if (this.isResizingLogo) {
      this.isResizingLogo = false;
      this.resizeCorner = null;
      this.dragOffset = { x: 0, y: 0 };
      this.initialPosition = null;
      const canvas = this.$refs.cardCanvas;
      if (canvas) {
        canvas.style.cursor = 'default';
      }
      // 保持选中状态
      this.drawCardPreview();
      return;
    }

    // 处理Logo拖拽结束
    if (this.isDraggingLogo) {
      this.isDraggingLogo = false;
      this.dragOffset = { x: 0, y: 0 };
      const canvas = this.$refs.cardCanvas;
      if (canvas) {
        canvas.style.cursor = 'default';
      }
      // 保持选中状态
      this.drawCardPreview();
      return;
    }

    if (!this.isDragging) return;

    this.isDragging = false;
    this.currentDraggedElement = null;
    this.currentDraggedText = null;
    this.dragOffset = { x: 0, y: 0 };
    this.isShiftPressed = false; // 重置Shift键状态
    this.initialPosition = null; // 重置初始位置
    this.dragDirection = null; // 重置移动方向
    this.showHitAreas = false; // 隐藏点击区域
    this.selectedTextType = null; // 清除选中状态

    // 恢复默认光标样式
    const canvas = this.$refs.cardCanvas;
    if (canvas) {
      canvas.style.cursor = 'default';
    }

    // 保存当前位置到默认设置
    this.saveCurrentPositions();

    // 重绘以隐藏区域
    this.drawCardPreview();
    },
    
    // 选择模板
    selectTemplate(template) {
      this.cardBackgroundImage = template.url;

      // 应用对应的配色方案
      if (template.colorScheme && this.colorSchemes[template.colorScheme]) {
        this.applyColorScheme(template.colorScheme);
      }
    },

    // 应用配色方案（只应用颜色，不改变位置）
    applyColorScheme(schemeName) {
      const scheme = this.colorSchemes[schemeName];
      if (!scheme) return;

      // 应用标题颜色设置
      this.fontSettings.title.color = scheme.title.color;
      this.fontSettings.title.strokeColor = scheme.title.strokeColor;
      this.fontSettings.title.strokeWidth = scheme.title.strokeWidth;

      // 应用批次号颜色设置
      this.fontSettings.batchNumber.color = scheme.batchNumber.color;
      this.fontSettings.batchNumber.strokeColor = scheme.batchNumber.strokeColor;
      this.fontSettings.batchNumber.strokeWidth = scheme.batchNumber.strokeWidth;

      // 应用卡密颜色设置
      this.fontSettings.cardNumber.color = scheme.cardNumber.color;
      this.fontSettings.cardNumber.strokeColor = scheme.cardNumber.strokeColor;
      this.fontSettings.cardNumber.strokeWidth = scheme.cardNumber.strokeWidth;

      // 应用有效期颜色设置
      this.fontSettings.validity.color = scheme.validity.color;
      this.fontSettings.validity.strokeColor = scheme.validity.strokeColor;
      this.fontSettings.validity.strokeWidth = scheme.validity.strokeWidth;

      // 应用网址颜色设置
      if (scheme.website) {
        this.fontSettings.website.color = scheme.website.color;
        this.fontSettings.website.strokeColor = scheme.website.strokeColor;
        this.fontSettings.website.strokeWidth = scheme.website.strokeWidth;
      }

      // 应用分隔线颜色设置
      this.separatorColor = scheme.separator.color;
      this.separatorWidth = scheme.separator.width;

      // 应用logo设置（颜色、蒙版形状从配色方案加载，大小是当前全局值）
      if (scheme.logo) {
        this.fontSettings.logo.color = scheme.logo.color;
        this.fontSettings.logo.maskShape = scheme.logo.maskShape;
        // fontSize 和 bgSize 保持当前全局值（由用户统一控制）
        // 将当前大小同步到此配色方案，确保保存时包含最新大小
        scheme.logo.fontSize = this.fontSettings.logo.fontSize;
        scheme.logo.bgSize = this.fontSettings.logo.bgSize;
      }

      // 将当前Logo大小同步到所有其他配色方案，保持全局统一
      const currentFontSize = this.fontSettings.logo.fontSize;
      const currentBgSize = this.fontSettings.logo.bgSize;
      Object.keys(this.colorSchemes).forEach(name => {
        if (name !== schemeName && this.colorSchemes[name].logo) {
          this.colorSchemes[name].logo.fontSize = currentFontSize;
          this.colorSchemes[name].logo.bgSize = currentBgSize;
        }
      });

      // 不再应用位置信息，位置是全局共享的
      // 重新绘制预览
      if (this.cardBackgroundImage) {
        this.drawCardPreview();
      }
    },

    // 获取配色方案的颜色（用于UI显示）
    getSchemeColor(schemeName) {
      const scheme = this.colorSchemes[schemeName];
      return scheme ? scheme.title.strokeColor : '#666666';
    },

    // 保存所有模板配色方案到数据库（保存当前位置到所有模板）
    async saveAllTemplates() {
      if (!confirm('确定要保存所有模板的配色方案吗？\n当前的位置设置将同步到所有模板。')) {
        return;
      }

      try {
        // 构建当前位置信息
        const currentPosition = {
          textPositions: JSON.parse(JSON.stringify(this.textPositions)),
          separatorPosition: JSON.parse(JSON.stringify(this.separatorPosition))
        };

        // 遍历所有模板，保存颜色配置和位置信息
        let savedCount = 0;
        for (const template of this.backgroundTemplates) {
          const schemeName = template.colorScheme;
          if (!schemeName || !this.colorSchemes[schemeName]) continue;

          // 构建配色方案数据（保留原有颜色 + 当前位置）
          const scheme = {
            ...this.colorSchemes[schemeName],
            textPositions: JSON.parse(JSON.stringify(currentPosition.textPositions)),
            separatorPosition: JSON.parse(JSON.stringify(currentPosition.separatorPosition))
          };

          // 保存到数据库
          await axios.post('api/card-color-scheme/save/', {
            scheme_name: schemeName,
            scheme: scheme
          }, {
            withCredentials: true,
            xsrfCookieName: 'csrftoken',
            xsrfHeaderName: 'X-Csrftoken'
          });

          // 更新本地配色方案
          this.colorSchemes[schemeName] = scheme;
          savedCount++;
        }

        alert(`已成功保存 ${savedCount} 个模板配色方案！\n位置已同步到所有模板。`);
      } catch (error) {
        console.error('保存所有模板失败:', error);
        let errorMsg = '保存失败！';
        if (error.response) {
          if (error.response.status === 403) {
            errorMsg = '权限不足，仅管理员可执行此操作';
          } else if (error.response.data && error.response.data.message) {
            errorMsg = error.response.data.message;
          }
        }
        alert(errorMsg);
      }
    }
  }
};
